import { updatedBySchema, uuidSchema } from "@qivia/schemas-shared";
import { z } from "zod";

export const vehicleDeactivatedPayloadSchema = z.object({
  vehicleUuid: uuidSchema,
  updatedBy: updatedBySchema,
});

export type PayloadForVehicleDeactivated = z.infer<
  typeof vehicleDeactivatedPayloadSchema
>;
